<template>
  <CHeader class="d-flex justify-content-between" fixed with-subheader light>
    <CToggler
      in-header
      class="ml-3 d-lg-none"
      @click="$store.commit('toggleSidebarMobile')"
    />
    <CToggler
      in-header
      class="ml-3 d-md-down-none"
      @click="$store.commit('toggleSidebarDesktop')"
    />
    <CHeaderBrand class="mx-auto d-lg-none" to="/">
      <img src="../assets/logo.svg">
    </CHeaderBrand>
    <select v-model="currentLanguage">
      <option value="pt">{{ $t("portuguese") }}</option>
      <option value="en">{{ $t("english") }}</option>
    </select>
  </CHeader>
</template>

<script>
export default {
  name: 'TheHeader',
  data() {
    return {
      currentLanguage: this.$i18n.locale
    }
  },
  watch: {
    currentLanguage: function (val) {
      this.$i18n.locale = val;
      localStorage.setItem('locale', val);
      // force a full page reload to get the correct language route
      window.location.href = '/';
    }
  }
}
</script>

<style scoped>
body > div > div.c-wrapper > header > a > img
{
  height: 48px;
  width: auto;
}
select {
  background: transparent;
  border: none;
  color: white;
  padding-right: 0.5rem;
  margin-right: 1rem;
  cursor: pointer;
}

select>option {
  color: black;
}
</style>